
import Vue from 'vue';
import { Button } from '@descomplica/vue-components';
import { LocaleMessages } from 'vue-i18n';
import i18n from '../i18n';

const types: { [key: string]: { [key: string]: string | LocaleMessages } } = {
  schedule: {
    iconSrc: `${process.env.BASE_URL}img/user-pc.svg`,
    btnLabel: i18n.t('testSchedule'),
  },
  paymentSlip: {
    iconSrc: `${process.env.BASE_URL}img/window-select.svg`,
    btnLabel: i18n.t('seePaymentSlip'),
  },
};

export default Vue.extend({
  components: {
    Button,
  },
  props: {
    text: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    src: {
      type: String,
      default: '',
    },
    target: {
      type: String,
      default: '',
    },
  },
  computed: {
    iconSrc(): String | LocaleMessages {
      return types[this.type].iconSrc;
    },
    btnLabel(): String | LocaleMessages {
      return types[this.type].btnLabel;
    },
  },
  methods: {
    onClickHandler() {
      if (this.src) window.open(this.src, this.target);
    },
  },
});
